import * as React from "react";
import { Link } from "react-router-dom";
import "./routes.css";
import annsRoom from "../img/annsroom.jpg";
import annsRoomLg from "../img/annsroom_lg.jpg";
import staffsRoom from "../img/staffsroom.jpg";
import staffsRoomLg from "../img/staffsroom_lg.jpg";

function GreenStudio() {
  return (
    <div className="pageBg">
      <div className="container">
        <div className="pageCard">
          <h2 className="pageTitle">Our Green Studio</h2>

          <p className="pageLead">
            We&rsquo;re all about health, and what better way to support it
            than a studio in harmony with the environment: low energy use,
            completely nontoxic insulation, radiant floor heat and hot water
            from solar panels.
          </p>

          <p>
            We believe in green business and taking care of the environment as
            a way to improve the quality of life on this planet and the health
            of all of us. We&rsquo;re doing our best to do our share by
            recycling, heating and lighting with as much renewable energy as we
            possibly can and using non-toxic materials, including the
            insulation in our building. The majority of our heat is provided
            by solar panels on our roof, which heat the water, which runs
            through our radiant floor heating system. We have skylights in our
            airy, cathedral ceiling studios to provide passive heat and light.
            Very cozy and warm in the winter, bamboo shades and foliage provide
            passive cooling in the summer.
          </p>

          <div className="missionQuote">
            <strong>Please be fragrance free</strong> in our environment, as
            some of our clients are exceptionally sensitive.
          </div>

          <div className="row g-4 mt-2">
            <div className="col-md-6">
              <h4 className="subTitle">Our Waiting Room</h4>
              <ul className="featureList">
                <li>
                  A small store with CDs, DVDs and wellness items, also
                  available in our <Link to="/store">online store</Link>.
                </li>
                <li>A variety of complimentary tea.</li>
                <li>A futon for the limber and a bench for firm seating.</li>
              </ul>
            </div>
            <div className="col-md-6">
              <h4 className="subTitle">Our Entrance: Semi-Accessible</h4>
              <ul className="featureList">
                <li>The walkway consists of sections three to 15 feet long.</li>
                <li>
                  Seven steps to the door, each rising only six inches from the
                  driveway to the entrance.
                </li>
                <li>
                  Please let us know if you have special needs. We will do our
                  best to make it accessible for you.
                </li>
              </ul>
            </div>
          </div>

          <h3 className="sectionTitle">Our Treatment Rooms</h3>
          <div className="row g-4">
            <div className="col-md-6">
              <a href={annsRoomLg} target="_blank" rel="noreferrer">
                <img
                  src={annsRoom}
                  className="roomPhoto"
                  alt="Ann's treatment room"
                />
              </a>
              <p className="photoCaption">
                <strong>Ann&rsquo;s Room</strong>
                <span>Click to enlarge</span>
              </p>
            </div>
            <div className="col-md-6">
              <a href={staffsRoomLg} target="_blank" rel="noreferrer">
                <img
                  src={staffsRoom}
                  className="roomPhoto"
                  alt="Staff treatment room"
                />
              </a>
              <p className="photoCaption">
                <strong>Staff&rsquo;s Room</strong>
                <span>Click to enlarge</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default GreenStudio;
